import { toFormElementFromParameter } from "../../../../../global/functions/mappingForParameterToFormElement";

export default {
  data() {
    return {
      jsonParam: {
        bez: "_LBL_ANTRAG_BUDGETKONTO_DIMENSIONEN_",
        default: null,
        help_text: "_TXT_ANTRAG_BUDGETKONTO_DIMENSIONEN_HELP_TEXT_",
        readonly: false,
        options: {
          allow_null: true,
          required: false
        },
        typ: "validated_json",
        many: true,
        as_json: false,
        unique_fields: ["dimension"],
        key_field: null,
        pos_field: null,
        min_length: null,
        max_length: null,
        element_label: "Dimensionsbeschreibung",
        element_template: "{{dimension}}: {{ermittlung}}",
        element_errors: true,
        fields: {
          dimension: {
            prio: 0,
            bez: "_LBL_ANTRAG_BUDGETKONTO_DIMENSIONEN_DIMENSION_",
            default: null,
            help_text: "_TXT_ANTRAG_BUDGETKONTO_DIMENSIONEN_DIMENSION_HELP_TEXT_",
            readonly: false,
            options: {
              allow_null: false,
              required: true,
              displaymode: "select2"
            },
            typ: "single_choice",
            katalog: "fibu_buchungsdimension"
          },
          ermittlung: {
            prio: 1,
            bez: "_LBL_ANTRAG_BUDGETKONTO_DIMENSIONEN_ERMITTLUNG_",
            default: null,
            help_text: "_TXT_ANTRAG_BUDGETKONTO_DIMENSIONEN_ERMITTLUNG_HELP_TEXT_",
            readonly: false,
            options: {
              allow_null: true,
              required: false,
              displaymode: "select2"
            },
            typ: "single_choice",
            katalog: "fibu_dimensionmodul",
            dependency: "dimension"
          },
          bearbeitbar: {
            prio: 2,
            bez: "_LBL_ANTRAG_BUDGETKONTO_DIMENSIONEN_BEARBEITBAR_",
            default: false,
            help_text: "_TXT_ANTRAG_BUDGETKONTO_DIMENSIONEN_BEARBEITBAR_HELP_TEXT_",
            readonly: false,
            options: {
              allow_null: false,
              required: true
            },
            typ: "boolean"
          },
          pflichtfeld: {
            prio: 3,
            bez: "_LBL_ANTRAG_BUDGETKONTO_DIMENSIONEN_PFLICHTFELD_",
            default: false,
            help_text: "_TXT_ANTRAG_BUDGETKONTO_DIMENSIONEN_PFLICHTFELD_HELP_TEXT_",
            readonly: false,
            options: {
              allow_null: false,
              required: true
            },
            typ: "boolean"
          }
        },
        prio: 6,
        wert: null
      },
    };
  },
  computed: {
    jsonOptions() {
      return toFormElementFromParameter({
        obj: { dimensionen: this.jsonParam },
        showLabel: true,
      }).list[0];
    }
  }
};
